<template>
  <div style="background: #f5f5f5">
    <pcHeaders></pcHeaders>
    <div style="display: flex; justify-content: center; flex-direction: column; align-items: center">
      <div class="content">
        <div class="panel-heading">流程</div>
        <div class="panel-body">
          <div class="li">
            <div >1、下载发票模版>>></div>

            <div class="btn" @click="downloadTemplate">下载文件</div>
          </div>
          <div class="li">2、添写发票相关信息</div>
          <div>
            <img src="../../assets/images/kaifapiao.png" alt="">
          </div>
          <div class="li">3、将文件发送到邮箱363538718@qq.com</div>
          <div class="li">若有问题可联系手机13866881158</div>

        </div>
      </div>
    </div>

    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';

import pcBottom from '../component/bottom.vue';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom
  },

  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
     downloadTemplate() {
      const link = document.createElement('a');
      link.href = window.glob.baseURL + '/static/invoiceModel.doc'; 
      link.download = 'invoiceModel.doc'; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.content {
  min-height: 700px;
  background-color: #fff;
  width: 1138px;
  margin: 20px 0;
  border-radius: 4px;
  border: #337ab7 1px solid;
  border-color: #337ab7;
}
.panel-heading {
  font-size: 16px;
  line-height: 38px;
  padding-left: 20px;
  width: 100%;
  height: 38px;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}
.panel-body {
  padding: 15px;
}
.li {
  font-size: 16px;
  display: flex;
  align-items: center;
    margin-bottom: 20px;

  .btn {
    display: inline-block;
    padding: 6px 12px;
    margin-left: 10px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    color: #fff;
    background-color: #337ab7;
    border-radius: 4px;
  }
}
</style>
